import { useCopilotCommunication } from '@/components/composite/CopilotControl/hooks/useCopilotCommunication';
import { CopilotCommunicationResult } from '@/components/composite/CopilotControl/hooks/useCopilotCommunication.types';
import { getMessageId, useMessagesStore } from '@/components/composite/CopilotControl/hooks/useMessagesStore';
import type { QueryCopilotResponseData } from '@/pages/api/map-events/query-copilot.types';
import { useMapCopilotDataFlow } from './useMapCopilotDataFlow';

export interface MapCopilotCommunicationProps {
  onDataChange?: (data: QueryCopilotResponseData, query?: string) => void;
  onResponseDone?: (message: string) => void;
}

export const useMapCopilotCommunication = ({
  onDataChange,
  onResponseDone,
}: MapCopilotCommunicationProps): CopilotCommunicationResult => {
  const store = useMessagesStore({ storageKey: 'map' });

  const queryFlow = useMapCopilotDataFlow({
    enabled: !!store.lastUserMessage,
    messageId: `copilot-${store.lastUserMessage?.messageId ?? getMessageId()}`,
    question: store.lastUserMessage?.message,
    onDataChange,
    onResponseDone,
  });

  return useCopilotCommunication({ queryFlow, store });
};
